import type { SearchParamsObject } from '@algolia/client-search';

import type { ApiAreaOfFocus } from '#/api/types/ApiAreaOfFocus';
import type { I18nFn } from '#/i18n/types/I18nFn';
import { I18N_LOCALES } from '#/i18n/types/I18nLocale';
import { searchAlgoliaOptionsFiltersForFacets } from '#/modules/search/algolia/options/searchAlgoliaOptionsFiltersForFacets';
import { unstableVolopSearchFacets } from '#/modules/search/constants/useSearchFacetsVolop';
import type { SearchFiltersById } from '#/modules/search/types/SearchFiltersById';
import type { SearchLocation } from '#/modules/search/types/SearchLocation';
import { algoliaQueryStringFilter } from '#/utils/algolia/helpers/algoliaQueryStringFilter';
import { SEARCH_PAGE_SIZE } from '#/utils/constants/general/searchPageSize';

const attributesToRetrieve = ['*'];

type Args = {
  i18n: I18nFn;
  filtersById: SearchFiltersById;
  searchLocation: SearchLocation | undefined;
  excludedAreasOfFocus: ApiAreaOfFocus[];
  distinct?: boolean;
};

export function searchAlgoliaVolopsOptions({
  i18n,
  filtersById,
  searchLocation,
  excludedAreasOfFocus,
  distinct,
}: Args): SearchParamsObject {
  return {
    ...(distinct && { distinct: 1 }),
    facets: ['*'],
    hitsPerPage: SEARCH_PAGE_SIZE,
    attributesToSnippet: ['description:20'],
    attributesToRetrieve,
    filters: [
      `${algoliaQueryStringFilter('actionType', 'VOLOP')}`,
      ...searchAlgoliaOptionsFiltersForFacets({
        filtersById,
        searchFacets: unstableVolopSearchFacets(i18n),
        searchLocation,
      }),
      ...excludedAreasOfFocus.map(
        (areaOfFocus) => `(NOT areasOfFocus:'${areaOfFocus}')`,
      ),
    ].join(' AND '),
    removeStopWords: true,
    ignorePlurals: true,
    advancedSyntax: true,
    queryLanguages: I18N_LOCALES,
  } satisfies SearchParamsObject;
}
